/* Etsy product page behaviors:
   - favorites (localStorage "etsy-favorites", array of product handles, event delegation)
   - sale countdown ticker ([data-sale-end])
   - personalization live character counter
   - sticky mobile add-to-cart bar (IntersectionObserver on the real submit button)
   Standalone: no dependency on other modules' JS. */
(function () {
  'use strict';

  var FAV_KEY = 'etsy-favorites';

  function readFavorites() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(FAV_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(list) {
    try {
      window.localStorage.setItem(FAV_KEY, JSON.stringify(list));
    } catch (error) {
      /* storage unavailable: ignore */
    }
  }

  /* Favorites click handling lives in etsy-recently-viewed.js (loaded globally);
     this sync only paints initial state in case that script loads later. */
  function syncFavoriteButtons() {
    var favorites = readFavorites();
    document.querySelectorAll('[data-etsy-fav]').forEach(function (button) {
      var handle = button.getAttribute('data-etsy-fav') || button.getAttribute('data-product-handle');
      var active = favorites.indexOf(handle) !== -1;
      button.classList.toggle('is-favorited', active);
      button.classList.toggle('etsy-fav-btn--active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = button.querySelector('[data-etsy-fav-label]');
      if (label) label.textContent = active ? 'Added to favorites' : 'Add to favorites';
    });
  }

  /* Sale countdown -------------------------------------------------- */
  function pad(value) {
    return value < 10 ? '0' + value : '' + value;
  }

  function tickCountdowns() {
    var nodes = document.querySelectorAll('[data-sale-end]');
    if (!nodes.length) return;
    var now = Date.now();
    nodes.forEach(function (node) {
      var end = Date.parse(node.getAttribute('data-sale-end') || '');
      if (isNaN(end) || end <= now) {
        node.hidden = true;
        node.textContent = '';
        return;
      }
      var totalSeconds = Math.floor((end - now) / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      node.hidden = false;
      node.textContent = 'Sale ends in ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    });
  }

  window.setInterval(tickCountdowns, 1000);

  /* Personalization character counter ------------------------------- */
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!field || !field.hasAttribute || !field.hasAttribute('data-etsy-personalization')) return;
    var wrapper = field.closest('.etsy-personalization');
    var counter = wrapper ? wrapper.querySelector('[data-etsy-personalization-count]') : null;
    if (!counter) return;
    counter.textContent = field.value.length + '/' + (field.getAttribute('maxlength') || '');
  });

  /* Skip empty personalization values so no empty line item property is
     added to the cart. Capture phase runs before Dawn's product-form
     submit handler builds its FormData. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      // form.id is shadowed by the variant <input name="id"> inside product forms, so read the attribute instead
      var formId = form && form.getAttribute ? (form.getAttribute('id') || '') : '';
      if (!formId || formId.indexOf('product-form-') !== 0) return;
      document.querySelectorAll('[data-etsy-personalization][form="' + formId + '"]').forEach(function (field) {
        if (field.value.trim() !== '') return;
        field.disabled = true;
        window.setTimeout(function () {
          field.disabled = false;
        }, 0);
      });
    },
    true
  );

  /* Sticky mobile add-to-cart bar ----------------------------------- */
  function initStickyBars() {
    document.querySelectorAll('[data-etsy-sticky-atc]').forEach(function (bar) {
      var sectionId = bar.getAttribute('data-section-id');
      if (!sectionId) return;
      var submitButton = document.getElementById('ProductSubmitButton-' + sectionId);
      var form = document.getElementById('product-form-' + sectionId);
      if (!submitButton || !form) return;

      bar.removeAttribute('hidden');

      var stickyButton = bar.querySelector('[data-etsy-sticky-submit]');
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          if (submitButton.hasAttribute('disabled')) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitButton);
          } else {
            submitButton.click();
          }
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              bar.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { threshold: 0 }
        );
        observer.observe(submitButton);
      }

      /* Keep sticky price and button state in sync with variant changes */
      var mainPrice = document.getElementById('price-' + sectionId);
      var stickyPrice = bar.querySelector('.etsy-sticky-atc__price');
      var syncFromMain = function () {
        if (mainPrice && stickyPrice) {
          var source = mainPrice.querySelector('.price');
          var target = stickyPrice.querySelector('.price');
          if (source && target) target.innerHTML = source.innerHTML;
        }
        if (stickyButton) {
          var disabled = submitButton.hasAttribute('disabled');
          stickyButton.toggleAttribute('disabled', disabled);
          var mainLabel = submitButton.querySelector('span');
          if (mainLabel && mainLabel.textContent.trim()) {
            stickyButton.textContent = mainLabel.textContent.trim();
          }
        }
      };
      if ('MutationObserver' in window) {
        if (mainPrice) {
          new MutationObserver(syncFromMain).observe(mainPrice, { childList: true, subtree: true });
        }
        new MutationObserver(syncFromMain).observe(submitButton, {
          attributes: true,
          childList: true,
          subtree: true,
        });
      }
    });
  }

  function init() {
    initStickyBars();
    syncFavoriteButtons();
    tickCountdowns();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
